import { CarHistoryDTO } from "./DTO/carHistoryDTO";
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/semi */
import { Device } from "./device";
import { WifiInfo } from "./WifiInfo";
import { CarDTO } from "./DTO/carDTO";
import { OSSObject } from "./OSSObject";
import { DeviceType } from "./device-type";
import { Base } from "./base";

export class Car extends OSSObject {
  __iAm: string = "Car";
  _page = "Car";

  public id = "temp";
  public name = "";
  public make = "";
  public model = "";
  public licensePlate = "";

  public wifi: WifiInfo = WifiInfo.factory();
  //public wifi = ''
  //public cntWifis = 0

  public batteryCapacity: number = 0;
  public batteryVoltage: number = 12;
  public batType = "LEAD_ACID";

  //public voltage: { 'lower': number; 'upper': number; 'color':string } = { 'lower': 0, 'upper': 0, 'color': '' }
  //public amperage: { 'lower': number; 'upper': number; 'color':string } = { 'lower': 0, 'upper': 0, 'color': '' }

  public current_pressure = -9999;
  public current_current = -9999;
  public current_voltage = -9999;
  public current_temperature = -9999;
  public current_humidity = -9999;

  /*
  public last_current: number
  public last_voltage: number
  public last_temperature: number
  public last_humidity: number
  public last_pressure: number


  color_date: string = ''
  color_voltage: string = ''
  color_temperature: string = ''
  color_pressure: string = ''
  color_current: string = ''

  color_current_voltage: string = ''
  color_current_temperature: string = ''
  color_current_pressure: string = ''
  color_current_current: string = ''
*/
  six: string = "selected";
  twelve: string = "";
  twentyfour: string = "";

  public image: string = "./assets/noimage.png";
  public imageDataUrl: string;
  public imageBase64String: string; //= "noimage.jpg"

  public installedDeviceId: string;

  public macaddress = "";
  public last_update: Date = null;
  public device: Device = new Device("", "", "", WifiInfo.factory(), "", "");

  wifiStateBackend = "";

  public history: CarHistoryDTO = new CarHistoryDTO();

  public voltageThresholds: {
    min: number;
    max: number;
  };

  public currentThresholds: {
    min: number;
    max: number;
  };

  public last: {
    voltage: {
      status: string;
      value: number;
    };
    current: {
      status: string;
      value: number;
    };
    temperature: {
      status: string;
      value: number;
    };
    humidity: {
      status: string;
      value: number;
    };
    pressure: {
      status: string;
      value: number;
    };
    timestamp: {
      status: string;
      value: number;
    };
    wifiSsid: {
      status: string;
      value: string;
    };
  };

  constructor() {
    super();

    this.voltageThresholds = { min: 12, max: 14.4 };

    this.last = {
      voltage: {
        status: "",
        value: 1,
      },
      current: {
        status: "",
        value: 0,
      },
      temperature: {
        status: "",
        value: 0,
      },
      humidity: {
        status: "",
        value: 0,
      },
      pressure: {
        status: "",
        value: 0,
      },
      timestamp: {
        status: "",
        value: 0,
      },
      wifiSsid: {
        status: "",
        value: "",
      },
    };

    //    this.voltage.lower = 12
    //    this.voltage.upper = 14
  }

  shortendname() {
    if (this.name !== null && this.name !== undefined && this.name.length > 15) {
      return this.name.substring(0, 13) + "..";
    } else {
      return this.name;
    }
  }

  shortendlicensePlate() {
    if (this.licensePlate !== null && this.licensePlate !== undefined && this.licensePlate.length > 15) {
      return this.licensePlate.substring(0, 13) + "..";
    } else {
      return this.licensePlate;
    }
  }

  public setDataFromDTO(carDTO: CarDTO) {
    Base.log("[" + this._page + "] setDTOFromModel");
    Base.log(carDTO);

    this.make = carDTO.make;
    this.installedDeviceId = carDTO.installedDeviceId;
    this.model = carDTO.model;
    this.name = carDTO.name;
    this.licensePlate = carDTO.licensePlate;
    this.id = carDTO.id;
    this.batteryCapacity = carDTO.batteryCapacity;
    this.batType = carDTO.batteryType;
    this.batteryVoltage = carDTO.batteryVoltage;
    //this.image = carDTO.image
    this.wifi = carDTO.wifi;
    this.last = carDTO.last;

    this.voltageThresholds = carDTO.voltageThresholds;
    this.currentThresholds = carDTO.currentThresholds;

    if (carDTO.last.current.value !== null) {
      this.last.current.value = carDTO.last.current.value; // / 1000
    }
    if (carDTO.last.voltage.value !== null) {
      this.last.voltage.value = carDTO.last.voltage.value;
    }
    if (carDTO.last.humidity.value !== null) {
      this.last.humidity.value = carDTO.last.humidity.value;
    }
    if (carDTO.last.pressure.value !== null) {
      this.last.pressure.value = carDTO.last.pressure.value;
    }
    if (carDTO.last.temperature.value !== null) {
      this.last.temperature.value = carDTO.last.temperature.value;
    }
    if (carDTO.last.timestamp.value !== null && carDTO.last.timestamp.value !== undefined) {
      this.last_update = new Date(carDTO.last.timestamp.value);
    } else {
      this.last_update = null;
    }

    /*
    this.voltage.lower = +carDTO.voltageThresholds.min
    this.voltage.upper = +carDTO.voltageThresholds.max
    this.amperage.lower = +carDTO.currentThresholds.min
    this.amperage.upper = +carDTO.currentThresholds.max
*/
    Base.log("[" + this._page + "] carDTO:");
    Base.log(this);
  }

  hasDevice() {
    return this.installedDeviceId !== null && this.installedDeviceId !== undefined && this.installedDeviceId !== "";
  }

  public getDeviceType() {
    let returner: DeviceType = DeviceType.Dev50;
    if (this.installedDeviceId !== null && this.installedDeviceId !== undefined && this.installedDeviceId !== "") {
      if (this.installedDeviceId.substring(0, 3) === "050") {
        returner = DeviceType.Dev50;
      } else if (this.installedDeviceId.substring(0, 3) === "052") {
        returner = DeviceType.Dev52;
      } else {
        returner = DeviceType.Dev51;
      }
    } else {
      returner = DeviceType.Dev50;
    }
    return returner;
  }

  async hasWifis(i) {
    if (this.installedDeviceId !== "") {
      return this.device.wifiStateBackend;
    } else {
      return false;
    }
    //this.installedDeviceId.get
    //if (this.cntWifis !== null && this.cntWifis !== undefined && this.cntWifis >0) {
    //const wifi = await this.device.getWifi(Base.extDataService)
    //console.log(wifi)
  }

  // generate toString() methode
  toString(): string {
    return JSON.stringify(this);
  }
}

export class cStatusValue {
  status: string = "";
  value: number = 0;
}

export class cLast {
  voltage: cStatusValue = new cStatusValue();
  current: cStatusValue = new cStatusValue();
  temperature: cStatusValue = new cStatusValue();
  humidity: cStatusValue = new cStatusValue();
  pressure: cStatusValue = new cStatusValue();
  timestamp: cStatusValue = new cStatusValue();
}
